module.exports = __webpack_public_path__ + "img/cleaf_home_logo.3808fd47.png";